var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large_review",
    transform: "translate(-193.000000, -237.000000)",
    fill: "#7ED321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.927885,238.677083 C207.975961,238.774306 208,238.847223 208,238.895833 C208,238.944444 207.975961,239.01736 207.927885,239.114583 L198.949519,250.78125 C198.805288,250.927084 198.697115,251 198.625,251 C198.504806,251 198.384617,250.939237 198.264423,250.817708 L193.180288,245.859375 L193.072115,245.75 C193.024038,245.652777 193,245.57986 193,245.53125 C193,245.506944 193.024038,245.446181 193.072115,245.348958 L193.144231,245.276042 C193.817311,244.54687 194.346152,243.987848 194.730769,243.598958 C194.875001,243.453125 194.971154,243.380208 195.019231,243.380208 C195.115385,243.380208 195.235576,243.453125 195.379808,243.598958 L198.264423,246.442708 L205.475962,237.072917 C205.524038,237.024306 205.596153,237 205.692308,237 C205.764423,237 205.848557,237.024306 205.944712,237.072917 L207.927885,238.677083 Z",
    id: "Page-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e3e06e06ee391193f9981feb29d8c576.svg";
export { ForwardRef as ReactComponent };